import { sportAliases } from '@/helpers/common.values';

export function getIconAlias(id: number) {
  return sportAliases[id];
}
